import { mapGetters } from 'vuex';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';

export default {
    name: 'agentInputGeo',
    inject: ['$eventBus'],
    data: function() {
        return {
            geoInfo: {
                text: '',
                geo: null
            },
            loaded: false
        };
    },
    components: {
        mvtInputGeo
    },
    computed: {
        ...mapGetters('glb', ['glb'])
    },
    watch:{
        geoInfo(newVal){
            if(newVal){
                this.$eventBus.$emit('eventbus-survey', {
                    text: newVal.text,
                    geo: newVal.geo,
                    type: 'agents'
                });
            }
        }
    },
    mounted() {
        if (this.glb.geo && this.glb.geo.city) {
            this.geoInfo.text = `${this.glb.geo.city} ${this.glb.geo.state || ''}`;
        }
        this.loaded = true;
    }
};
